import {URL} from "utils/constants";
import axios from "axios";

// Function to create a new thread
export const createThread = async params => {
  const userId = params.userId;
  try {
    const response = await axios.post(`${URL.CHATBOT_SERVER}/create/thread`, {
      userId,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating thread:", error);
  }
};

// Function to send a chat message
export const sendMessage = async params => {
  const {userId, message} = params;
  try {
    const response = await axios.post(`${URL.CHATBOT_SERVER}/chat`, {
      userId,
      message,
    });
    return response.data;
  } catch (error) {
    console.error("Error sending message:", error);
  }
};
